import { Component, OnInit, Input } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import {
  FormControl,
  FormGroup,
  Validators,
  FormBuilder,
} from '@angular/forms';
import { SettingsService } from '../../../core/http/settings.service';
import { ObsService } from '../../../core/http/obs.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as _moment from 'moment';
const moment = _moment;

@Component({
  selector: 'app-third-trimester',
  templateUrl: './third-trimester.component.html',
  styleUrls: ['./third-trimester.component.scss'],
})
export class ThirdTrimesterComponent implements OnInit {
  @Input() Patient_type;
  @Input() gender;
  @Input() AmnioticFluid;
  @Input() CervicalOs;
  @Input() Chorionicity;
  @Input() Amnionicity;
  @Input() Grade;
  @Input() PlacentaLocation;
  @Input() PlacentaLocationAnatomic;
  @Input() Presentation;
  @Input() FetalAnomaly;
  @Input() NoofFetus;
  @Input() TechnicalConditions;
  @Input() FetalHeartBeat;
  @Input() fetalLie;
  @Input() image1;
  @Input() image2;
  @Input() disable;

  repeat = false;
  trimister = false;
  copy = false;
  isLoading = false;
  response: any = [];
  result_id;
  form: FormGroup;
  patient;
  FetchPatient;
  drs: any = [];
  firstPic;
  fullImage;
  result: any = [];
  disabled: boolean = true;
  data: any = [];
  fetus = '';

  constructor(
    private modal: ModalService,
    private _snackBar: MatSnackBar,
    public auth: SettingsService,
    private obs: ObsService,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.patient = this.obs._patient;
    this.obs.getPatient(this.obs._patient.patient_id).subscribe(
      (resSuccess) => {
        this.FetchPatient = resSuccess[0];
        this.form.patchValue({
          result_id: this.patient.result_id,
          data: {
            patient_id: this.patient.patient_id,
            referance_id: this.FetchPatient.ref_doct_code,
            branch_code: this.FetchPatient.Branch_Code,
            author_id: this.FetchPatient.Author_id,
          },
        });
        this.fetchResult();
        console.log(this.form.value);
        console.log(this.FetchPatient);
      },
      (resErr) => {}
    );

    this.obs.getDrs().subscribe(
      (resSuccess) => {
        this.drs = resSuccess;
      },
      (resErr) => {}
    );

    this.form = this.fb.group({
      result_id: [0],
      data: this.fb.group({
        TTremester_id: [''],
        patient_id: [''],
        referance_id: [''],
        author_id: [''],
        branch_code: [''],
        sex: [''],
        lmp: [''],
        ga: [''],
        edd: [''],
        no_of_fetus: [''],
        fetal_heart_beat: [''],
        presentation: [''],
        fetus_lie: [''],
        bpd: [''],
        fl: [''],
        ac: [''],
        hc: [''],
        fet_weg: [''],
        gender: [''],
        us_average: [''],
        us_edd: [''],
        P_location_ana: [''],
        p_location: [''],
        amniotic_fluid: [''],
        fet: [''],
        cervical_os: [''],
        comments: [''],
        fetus: [''],
        ftimage: [''],
        fin_year: [''],
        entry_date: [''],
        update_entry_date: [''],
        doctor_id: [''],
      }),
    });
  }

  fetchResult() {
    this.obs.getTT(this.patient.result_id).subscribe(
      (resSuccess: any) => {
        this.result = resSuccess;
        console.log(resSuccess);
        this.data = [...resSuccess];
        console.log(this.data);

        this.form.patchValue({
          data: {
            TTremester_id: this.result[0].data.TTremester_id,
            lmp: this.result[0].data.lmp,
            ga: this.result[0].data.ga,
            edd: this.result[0].data.edd,
            no_of_fetus: this.result[0].data.no_of_fetus,
            fetal_heart_beat: this.result[0].data.fetal_heart_beat,
            presentation: this.result[0].data.presentation,
            fetus_lie: this.result[0].data.fetus_lie,
            bpd: this.result[0].data.bpd,
            fl: this.result[0].data.fl,
            ac: this.result[0].data.ac,
            hc: this.result[0].data.hc,
            fet_weg: this.result[0].data.fet_weg,
            gender: this.result[0].data.gender,
            us_average: this.result[0].data.us_average,
            us_edd: this.result[0].data.us_edd,
            P_location_ana: this.result[0].data.P_location_ana,
            p_location: this.result[0].data.p_location,
            amniotic_fluid: this.result[0].data.amniotic_fluid,
            fet: this.result[0].data.fet,
            cervical_os: this.result[0].data.cervical_os,
            comments: this.result[0].data.comments,
            fetus: this.result[0].data.fetus,
            ftimage: this.result[0].data.ftimage,
            fin_year: this.result[0].data.fin_year,
            entry_date: this.result[0].data.entry_date,
            update_entry_date: this.result[0].data.update_entry_date,
            doctor_id: this.result[0].data.doctor_id,
          },
        });
        this.obs.getImage(this.result[0].data.ftimage).subscribe(
          (resSuccess) => {
            this.fullImage = resSuccess;
          },
          (resErr) => {}
        );
        console.log(this.form.value);
      },
      (resErr) => {}
    );
  }

  add() {
    if (this.fetus == 'A') {
      console.log('dr id', this.form.value);
      this.result.splice(0, 1, this.form.value);
      this._snackBar.open('Fetus A added', '', {
        duration: 2000,
        verticalPosition: 'top',
      });
    } else if (this.fetus == 'B') {
      this.result.splice(1, 1, this.form.value);
      this._snackBar.open('Fetus B added', '', {
        duration: 2000,
        verticalPosition: 'top',
      });
      console.log('splice');
    } else if (this.fetus == 'C') {
      this.result.splice(2, 1, this.form.value);
      this._snackBar.open('Fetus C added', '', {
        duration: 2000,
        verticalPosition: 'top',
      });
    } else {
      this._snackBar.open('Please select fetus', '', {
        duration: 2000,
        verticalPosition: 'top',
      });
    }
    console.log(this.result);
    console.log(this.fetus);
    console.log(this.form.value);
  }

  changeFetus(event) {
    if (this.fetus == 'A') {
      this.form.patchValue({
        data: {
          TTremester_id: this.result[0].data.TTremester_id,
          lmp: this.result[0].data.lmp,
          ga: this.result[0].data.ga,
          edd: this.result[0].data.edd,
          no_of_fetus: this.result[0].data.no_of_fetus,
          fetal_heart_beat: this.result[0].data.fetal_heart_beat,
          presentation: this.result[0].data.presentation,
          fetus_lie: this.result[0].data.fetus_lie,
          bpd: this.result[0].data.bpd,
          fl: this.result[0].data.fl,
          ac: this.result[0].data.ac,
          hc: this.result[0].data.hc,
          fet_weg: this.result[0].data.fet_weg,
          gender: this.result[0].data.gender,
          us_average: this.result[0].data.us_average,
          us_edd: this.result[0].data.us_edd,
          P_location_ana: this.result[0].data.P_location_ana,
          p_location: this.result[0].data.p_location,
          amniotic_fluid: this.result[0].data.amniotic_fluid,
          fet: this.result[0].data.fet,
          cervical_os: this.result[0].data.cervical_os,
          comments: this.result[0].data.comments,
          fetus: this.result[0].data.fetus,
          ftimage: this.result[0].data.ftimage,
          fin_year: this.result[0].data.fin_year,
          entry_date: this.result[0].data.entry_date,
          update_entry_date: this.result[0].data.update_entry_date,
          doctor_id: this.result[0].data.doctor_id,
        },
      });
    } else if (this.fetus == 'B') {
      this.form.patchValue({
        data: {
          TTremester_id: this.result[1].data.TTremester_id,
          lmp: this.result[1].data.lmp,
          ga: this.result[1].data.ga,
          edd: this.result[1].data.edd,
          no_of_fetus: this.result[1].data.no_of_fetus,
          fetal_heart_beat: this.result[1].data.fetal_heart_beat,
          presentation: this.result[1].data.presentation,
          fetus_lie: this.result[1].data.fetus_lie,
          bpd: this.result[1].data.bpd,
          fl: this.result[1].data.fl,
          ac: this.result[1].data.ac,
          hc: this.result[1].data.hc,
          fet_weg: this.result[1].data.fet_weg,
          gender: this.result[1].data.gender,
          us_average: this.result[1].data.us_average,
          us_edd: this.result[1].data.us_edd,
          P_location_ana: this.result[1].data.P_location_ana,
          p_location: this.result[1].data.p_location,
          amniotic_fluid: this.result[1].data.amniotic_fluid,
          fet: this.result[1].data.fet,
          cervical_os: this.result[1].data.cervical_os,
          comments: this.result[1].data.comments,
          fetus: this.result[1].data.fetus,
          ftimage: this.result[1].data.ftimage,
          fin_year: this.result[1].data.fin_year,
          entry_date: this.result[1].data.entry_date,
          update_entry_date: this.result[1].data.update_entry_date,
          doctor_id: this.result[1].data.doctor_id,
        },
      });
    } else if (this.fetus == 'C') {
      this.form.patchValue({
        data: {
          TTremester_id: this.result[2].data.TTremester_id,
          lmp: this.result[2].data.lmp,
          ga: this.result[2].data.ga,
          edd: this.result[2].data.edd,
          no_of_fetus: this.result[2].data.no_of_fetus,
          fetal_heart_beat: this.result[2].data.fetal_heart_beat,
          presentation: this.result[2].data.presentation,
          fetus_lie: this.result[2].data.fetus_lie,
          bpd: this.result[2].data.bpd,
          fl: this.result[2].data.fl,
          ac: this.result[2].data.ac,
          hc: this.result[2].data.hc,
          fet_weg: this.result[2].data.fet_weg,
          gender: this.result[2].data.gender,
          us_average: this.result[2].data.us_average,
          us_edd: this.result[2].data.us_edd,
          P_location_ana: this.result[2].data.P_location_ana,
          p_location: this.result[2].data.p_location,
          amniotic_fluid: this.result[2].data.amniotic_fluid,
          fet: this.result[2].data.fet,
          cervical_os: this.result[2].data.cervical_os,
          comments: this.result[2].data.comments,
          fetus: this.result[2].data.fetus,
          ftimage: this.result[2].data.ftimage,
          fin_year: this.result[2].data.fin_year,
          entry_date: this.result[2].data.entry_date,
          update_entry_date: this.result[2].data.update_entry_date,
          doctor_id: this.result[2].data.doctor_id,
        },
      });
    }
    console.log(this.data);
  }

  getProp(prop) {
    return this[prop];
  }
  setProp(prop, value) {
    this[prop] = value;
  }

  DateChange(event: any) {
    this.form.patchValue({
      data: {
        entry_date: moment(event.target.value).format('YYYY-MM-DD'),
      },
    });
    console.log(this.form.value);
  }
  slectOnChange1(event) {
    this.firstPic = event.value;
    this.disabled = false;
  }
  slectOnChange(event) {
    let fullPic = this.firstPic + '/' + event.value + '.jpg';
    this.form.patchValue({
      data: {
        ftimage: fullPic,
      },
    });
    this.obs.getImage(fullPic).subscribe(
      (resSuccess) => {
        this.fullImage = resSuccess;
        console.log(resSuccess);
      },
      (resErr) => {}
    );
    console.log(this.form.value);
  }

  onSubmit(e) {
    // e.preventDefault();
    console.log(this.data);

    this.isLoading = true;
    const { result_id, data } = this.form.value;
    this.obs.postTT(this.result).subscribe(
      (resSuccess: []) => {
        this.response = resSuccess;
        this.isLoading = false;
        console.log(resSuccess);

        if (this.response.success) {
          this.form.reset();
          this.isLoading = false;
          this._snackBar.open('Saved Successfully', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        } else {
          this.isLoading = false;
          this._snackBar.open('Error: Please try again', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
          console.log(resSuccess);
        }
      },
      (resErr) => {
        this.isLoading = false;
        this._snackBar.open(resErr, '', {
          duration: 2000,
          verticalPosition: 'top',
        });
        console.log(resErr);
      }
    );
  }
}
